module.exports = __webpack_public_path__ + "media/icons/white-bell-37a7cef1.png";